import {
  Attribute,
  ChangeDetectorRef,
  Directive,
  EnvironmentInjector,
  ErrorHandler,
  ViewContainerRef,
} from '@angular/core';
import { ChildrenOutletContexts, Router, RouterOutlet, Event } from '@angular/router';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'rtc-detached-router-outlet',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class DetachedRouterOutlet extends RouterOutlet {
  private cdRef: ChangeDetectorRef;
  private context: Event[] = [];
  private ngOnDestroy$ = new Subject<void>();

  constructor(
    parentContexts: ChildrenOutletContexts,
    location: ViewContainerRef,
    // eslint-disable-next-line @angular-eslint/no-attribute-decorator
    @Attribute('name') name: string,
    changeDetector: ChangeDetectorRef,
    environmentInjector: EnvironmentInjector,
    router: Router,
    private errorHandler: ErrorHandler,
  ) {
    super(parentContexts, location, name, changeDetector, environmentInjector);
    this.cdRef = changeDetector;

    router.events.pipe(takeUntil(this.ngOnDestroy$)).subscribe(event => {
      this.context = [event, ...this.context].slice(0, 50);
    });
  }

  public activateWith(): void {
    try {
      super.activateWith.apply(this, arguments);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.info(this.context);
      this.errorHandler.handleError(e);
    }
    this.cdRef.detectChanges();
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
    super.ngOnDestroy();
  }
}
